import { LinkOptions } from '@tiptap/extension-link';
import { v4 } from 'uuid';

export interface LinkAttrs {
	id: string;
	href: string;
	target?: string;
}

export interface TrLinkOptions extends LinkOptions {
	trAutolink: boolean;
}

export const getLinkId = (): string => `link_${v4()}`;

// Link Validation:
// Any string that starts with http:// or https:// can be considered a URL
const PROTOCOL_MATCHER = /^http(s?):\/\/./;
// Alternately, a string ending in one of the top-20 TLDs plus some others
const ACCEPTED_TLDS = [
	'\\.com',
	'\\.org',
	'\\.ru',
	'\\.net',
	'\\.uk',
	'\\.au',
	'\\.in',
	'\\.de',
	'\\.ir',
	'\\.ca',
	'\\.jp',
	'\\.it',
	'\\.fr',
	'\\.tr',
	'\\.ua',
	'\\.vn',
	'\\.nl',
	'\\.pl',
	'\\.co',
	'\\.br',
	'\\.io',
	'\\.fr',
	'\\.info',
	'\\.eu',
	'\\.us',
	'\\.gov',
];
const TLD_MATCHER = new RegExp(`((${ACCEPTED_TLDS.join(')|(')}))$`);

export const validateLink = (urlCandidate: string): boolean => {
	if (urlCandidate.match(PROTOCOL_MATCHER)) {
		return true;
	}
	return Boolean(urlCandidate.match(TLD_MATCHER));
};
